import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { PreferencesForm } from '@/components/notifications/preferences-form';
import { PushPrompt } from '@/components/notifications/push-prompt';

export const Route = createFileRoute('/_app/settings/notifications')({
  component: NotificationSettingsPage,
});

function NotificationSettingsPage(): React.ReactElement {
  return (
    <div className="flex flex-col gap-6">
      <PushPrompt />
      <section className="border-border bg-card rounded-2xl border p-6 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)] md:p-8">
        <h2 className="font-display mb-4 text-base">Préférences de notification</h2>
        <p className="text-muted-foreground mb-6 text-xs">
          Gérez comment et quand vous êtes notifié.
        </p>
        <PreferencesForm />
      </section>
    </div>
  );
}
